/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import Session from 'supertokens-web-js/recipe/session';

import { ApiPaths } from '@fai/constants/shared-urls';
import { resetAllIntegrations } from '@fai/friendli-suite/features/auth/reset-all-integrations';
import { baseKy } from '@fai/friendli-suite/shared/ky/base-ky';

export const forceSignOut = async () => {
  const session = await Session.doesSessionExist();

  if (session) {
    await baseKy.post(ApiPaths.SignOut);
    await resetAllIntegrations();
  }

  return null;
};
